
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 125"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"brown","d":"M95.281 30.258H4.718V69.741h90.563L83.437 50l11.844-19.742zm-7.695 1.756H90.9v3.314h-3.314v-3.314zm-6.24 0h3.315v3.314h-3.315v-3.314zM9.787 67.986H6.472v-3.314h3.315v3.314zm0-32.658H6.472v-3.314h3.315v3.314zm6.24 32.658h-3.315v-3.314h3.315v3.314zm0-32.658h-3.315v-3.314h3.315v3.314zm6.239 32.658h-3.315v-3.314h3.315v3.314zm0-32.658h-3.315v-3.314h3.315v3.314zm6.24 32.658h-3.315v-3.314h3.315v3.314zm0-32.658h-3.315v-3.314h3.315v3.314zm6.239 32.658H31.43v-3.314h3.315v3.314zm0-32.658H31.43v-3.314h3.315v3.314zm6.239 32.658H37.67v-3.314h3.314v3.314zm0-32.658H37.67v-3.314h3.314v3.314zm6.24 32.658h-3.315v-3.314h3.315v3.314zm0-32.658h-3.315v-3.314h3.315v3.314zm6.24 32.658h-3.315v-3.314h3.315v3.314zm0-32.658h-3.315v-3.314h3.315v3.314zm6.239 32.658h-3.315v-3.314h3.315v3.314zm0-32.658h-3.315v-3.314h3.315v3.314zm6.238 32.658h-3.313v-3.314h3.313v3.314zm0-32.658h-3.313v-3.314h3.313v3.314zm6.24 32.658h-3.313v-3.314h3.313v3.314zm0-32.658h-3.313v-3.314h3.313v3.314zm6.24 32.658h-3.314v-3.314h3.314v3.314zm0-32.658h-3.314v-3.314h3.314v3.314zm9.165 29.344H90.9v3.314h-3.314v-3.314zm-2.925 0v3.314h-3.315v-3.314h3.315z"}})])
          )
        }
      }
    